import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

import { DoubleChevronClosedIcon, DoubleChevronOpenIcon } from '@/components/icons'

const OpenChangeEffect = ({ open, onOpenChange }) => {
  useEffect(() => {
    onOpenChange?.(open)
  }, [open, onOpenChange])
  return null
}

OpenChangeEffect.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func,
}

const CollapsibleSection = ({ title, badge, children, defaultOpen, onOpenChange }) => (
  <Disclosure defaultOpen={defaultOpen}>
    {({ open }) => (
      <>
        <OpenChangeEffect open={open} onOpenChange={onOpenChange} />
        <DisclosureButton className="w-full">
          <div className="flex flex-row items-center gap-4">
            <span className="text-charcoal-900 flex-none py-4 text-xl font-semibold">{title}</span>
            {badge}
            <div className="bg-charcoal-400 flex h-[1px] w-full" />
            <span>
              {open ? (
                <DoubleChevronOpenIcon className="h-4 fill-blue-800" />
              ) : (
                <DoubleChevronClosedIcon className="fill-charcoal-900 h-4" />
              )}
            </span>
          </div>
        </DisclosureButton>
        <Transition
          enter="transition ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <DisclosurePanel className="p-0 text-gray-500">{children}</DisclosurePanel>
        </Transition>
      </>
    )}
  </Disclosure>
)

CollapsibleSection.defaultProps = {
  badge: null,
  defaultOpen: true,
  onOpenChange: undefined,
}

CollapsibleSection.propTypes = {
  badge: PropTypes.node,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  onOpenChange: PropTypes.func,
}

export default CollapsibleSection
